<template>
  <v-dialog v-model="visible" persistent :max-width="width">
    <v-card>
      <v-card-title>{{ title }}</v-card-title>
      <v-card-text v-html="message"></v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn flat @click="cancel" v-if="isConfirm">取消</v-btn>
        <v-btn color="primary" flat @click="confirm">确定</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      type: "alert",
      title: "提示",
      message: "",
      resolve: null,
      width: 300
    };
  },
  computed: {
    isConfirm() {
      return this.type === "confirm";
    }
  },
  methods: {
    confirm() {
      this.visible = false;
      this.resolve.call(null, true);
    },
    cancel() {
      this.visible = false;
      this.resolve.call(null, false);
    }
  }
};
</script>
